import React, { useEffect, useState } from 'react';
import './Footer.css';
import { NavLink } from 'react-router-dom';

import facebookIcon from '../../assets/images/icons/facebookIcon.svg';
import instIcon from '../../assets/images/icons/instIcon.svg';
import skypeIcon from '../../assets/images/icons/skypeIcon.svg';
import telegramIcon from '../../assets/images/icons/telegramIcon.svg';
import whatsapIcon from '../../assets/images/icons/whatsUpIcon.svg';
import meeticon from '../../assets/images/icons/meetIcon.svg'
import linkedInIcon from '../../assets/images/icons/linkedIn.svg'

import phoneIcon from '../../assets/images/icons/phoneIcon.svg';
import emailIcon from '../../assets/images/icons/mailIcon.svg';
import locationIcon from '../../assets/images/icons/adressIcon.svg';

import HeaderLogo from '../../assets/images/Header/logo.png';
import { RiArrowDownSLine, RiArrowUpSLine } from 'react-icons/ri';

function Footer() {
  const year = new Date().getFullYear();

  const servicesCategories = [
    {
      id: 'gaming-license',
      name: 'Gaming License',
      links: [
        { name: 'Gaming License Services', link: '/gaming-license-services' },
        {
          name: 'iGaming & Gambling License – Western Sahara',
          link: '/igaming-gambling-western-sahara',
        },
        {
          name: 'Gaming License – Mwali (Comoros)',
          link: '/gaming-license-mwali',
        },
        {
          name: 'Gaming License – Anjouan (Comoros)',
          link: '/gaming-license-anjouan',
        },
        {
          name: 'Gibraltar iGaming License',
          link: '/gibraltar-igaming-license',
        },
        {
          name: 'Gaming & iGaming License – Malta (MGA)',
          link: '/gaming-igaming-license-malta',
        },
        {
          name: 'Gaming & Betting License – Cyprus',
          link: '/gaming-betting-license–cyprus',
        },
        {
          name: 'Gaming License – Panama',
          link: '/gaming-license–panama',
        },
        {
          name: 'Curaçao Gaming License',
          link: '/curaçao-gaming-license',
        },
        {
          name: 'Gaming & iGaming License – Seychelles',
          link: '/gaming-igaming-license–seychelles',
        },
        {
          name: 'Gaming & Betting License – Saint Lucia',
          link: '/gaming-betting-license–saint-lucia',
        },
      ],
    },
    {
      id: 'forex-brokerage',
      name: 'Forex & Brokerage License',
      links: [
        {
          name: 'Brokerage & Forex Licenses',
          link: '/brokerage-forex-licenses',
        },
        {
          name: 'Forex & Brokerage License in Western Sahara',
          link: '/forex-brokerage-license-western-sahara',
        },
        {
          name: 'Forex & Brokerage License – Mwali (Comoros)',
          link: '/forex-brokerage-license-mwali',
        },
        {
          name: 'Brokerage/FX & Clearing House License – Anjouan (Comoros)',
          link: '/brokerage-license-anjouan',
        },
        {
          name: 'Brokerage & Forex License – Malta (MFSA)',
          link: '/brokerage-forex-license-malta',
        },
        {
          name: 'Forex & Brokerage License – Cyprus (CySEC / CIF)',
          link: '/forex-brokerage-license-cyprus',
        },
        {
          name: 'Securities Dealer License – Seychelles',
          link: '/securities-dealer-license-seychelles',
        },
        {
          name: 'Forex & Brokerage – St. Vincent & the Grenadines',
          link: '/forex-brokerage-St-vincent-grenadines',
        },
      ],
    },
    {
      id: 'brokerage-forex-lic',
      name: 'Brokerage & Forex License',
      links: [
        {
          name: 'Brokerage License',
          link: '/brokerage-forex-license-malta',
        },
        {
          name: 'Brokerage – W. Sahara',
          link: '/brokerage-forex-license-malta',
        },
        {
          name: 'Brokerage – Mwali',
          link: '/brokerage-forex-license-malta',
        },
        {
          name: 'Brokerage – anjouan-offshore-offshore-company-formation',
          link: '/brokerage-forex-license-malta',
        },
        {
          name: 'Brokerage – Cyprus',
          link: '/brokerage-forex-license-malta',
        },
        {
          name: 'Brokerage – Seychelles',
          link: '/brokerage-forex-license-malta',
        },
        {
          name: 'Brokerage – Malta',
          link: '/brokerage-forex-license-malta',
        },
        {
          name: 'Brokerage – St. Lucia',
          link: '/brokerage-forex-license-malta',
        },
      ],
    },
    {
      id: 'banking',
      name: 'Banking License',
      links: [
        { name: 'Banking License', link: '/banking-license' },
        {
          name: 'Banking License – Malta (MFSA/ECB)',
          link: '/banking-license-malta',
        },
        {
          name: 'Banking License – Cyprus',
          link: '/banking-license-cyprus',
        },
        {
          name: 'Banking License – Panama',
          link: '/banking-license-panama',
        },
        {
          name: 'Banking License – Seychelles',
          link: '/banking-license-seychelles',
        },
        {
          name: 'Banking License – Mauritius',
          link: '/banking-license-mauritius',
        },
        {
          name: 'Banking License – Saint Lucia',
          link: '/banking-license-saint-lucia',
        },
        {
          name: 'Western Sahara Banking License',
          link: '/western-sahara-banking-license',
        },
        {
          name: 'Banking License – Mwali (Comoros)',
          link: '/banking-license-mwali',
        },
      ],
    },
    {
      id: 'crypto',
      name: 'Crypto & Blockchain',
      links: [
        {
          name: 'Crypto & Virtual Asset Licenses',
          link: '/crypto-virtual-asset-licenses',
        },
        {
          name: 'Crypto License – Western Sahara',
          link: '/crypto-license-western-sahara',
        },
        {
          name: 'Crypto License – Mwali',
          link: '/crypto-license-mwali',
        },
        {
          name: 'Crypto License – Anjouan',
          link: '/crypto-license-anjouan',
        },
        {
          name: 'Gibraltar Crypto & DLT License',
          link: '/gibraltar-crypto-dlt-license',
        },
        {
          name: 'Crypto & Blockchain License – Malta (VFA Act)',
          link: '/crypto-blockchain-license-malta',
        },
        {
          name: 'Crypto & Blockchain License – Cyprus (CySEC CASP)',
          link: '/crypto-blockchain-license-cyprus',
        },
        {
          name: 'Crypto License – Panama',
          link: '/crypto-license-panama',
        },
        {
          name: 'Crypto & Digital Asset License – Seychelles',
          link: '/crypto-digital-asset-license-seychelles',
        },
        {
          name: 'Crypto & VASP License – Mauritius',
          link: '/Crypto-vasp-license-mauritius',
        },
      ],
    },
    {
      id: 'trust',
      name: 'Trust & Insurance Licenses',
      links: [
        {
          name: 'Trust & Insurance Licenses',
          link: '/trust-insurance-licenses',
        },
        {
          name: 'Trust & Insurance Licenses - Western Sahara',
          link: '/trust-insurance-licenses-western-sahara',
        },
        {
          name: 'Trust & Insurance Licenses Mwali (Comoros)',
          link: '/trust-insurance-licenses-mwali',
        },
        {
          name: 'Trust & Insurance Licenses Anjouan (Comoros)',
          link: '/trust-insurance-licenses-anjouan',
        },
        {
          name: 'Gibraltar Insurance & Reinsurance License',
          link: '/gibraltar-insurance-reinsurance-license',
        },
        {
          name: 'Insurance & Reinsurance License – Malta (MFSA)',
          link: '/insurance-reinsurance-license-malta',
        },
        {
          name: 'Insurance & Reinsurance License – Cyprus',
          link: '/insurance-reinsurance-cyprus',
        },
        {
          name: 'Insurance & Reinsurance License – Panama',
          link: '/insurance-reinsurance-license-panama',
        },
        {
          name: 'Insurance & Captives – Isle of Man',
          link: '/insurance-captives-isle-man',
        },
        {
          name: 'Insurance & Reinsurance License – Mauritius',
          link: '/insurance-reinsurance-license-mauritius',
        },
      ],
    },
    {
      id: 'fund',
      name: 'Fund & Asset Management',
      links: [
        {
          name: 'Funds & Asset Management – Isle of Man',
          link: '/funds-asset-management-isle-man',
        },
        {
          name: 'Funds & Asset Management License – Malta (MFSA)',
          link: '/funds-asset-management-license-malta',
        },
        {
          name: 'Funds & Asset Management License – Cyprus (CySEC)',
          link: '/funds-asset-management-license-cyprus',
        },
        {
          name: 'Funds & Asset Management License – Panama',
          link: '/funds-asset-management-license-panama',
        },
        {
          name: 'Asset Management License – Mwali (Comoros)',
          link: '/asset-management-license-mwali',
        },
        {
          name: 'Funds & Asset Management License – Mauritius',
          link: '/funds-asset-management-license-mauritius',
        },
        {
          name: 'Asset Management License – Western Sahara',
          link: '/funds-asset-management-license-mauritius',
        },
      ],
    },
    {
      id: 'payment',
      name: 'Payment & FinTech',
      links: [
        {
          name: 'Payments & FinTech Licenses',
          link: '/payments-fintech-licenses',
        },
        {
          name: 'Gibraltar Banking & FinTech License',
          link: '/gibraltar-banking-finTech-license',
        },
        {
          name: 'Payment Services & EMI License – Malta (MFSA)',
          link: '/payment-services-EMI-license-malta',
        },
        {
          name: 'Payment Services & EMI License – Cyprus (Central Bank of Cyprus)',
          link: '/payment-services-EMI-license-cyrus',
        },
        {
          name: 'Payments & FinTech License – Mauritius',
          link: '/payments-fintech-license-mauritius',
        },
        {
          name: 'Payments & FinTech License – Seychelles',
          link: '/payments-fintech-license-seychelles',
        },
        {
          name: 'FinTech & Payments License – Panama',
          link: '/payments-fintech-license-panama',
        },
      ],
    },
  ];

  // --------- ДАННЫЕ ИЗ ХЕДЕРА (Jurisdictions) ----------
  const jurisdictionsCategories = [
    {
      id: 'jurisdictions',
      name: 'Jurisdictions',
      links: [
        {
          name: 'Western Sahara Jurisdiction',
          link: '/western-sahara-jurisdiction',
        },
        {
          name: 'Mwali Jurisdiction',
          link: '/mwali-jurisdiction',
        },
        {
          name: 'Anjouan Jurisdiction',
          link: '/anjouan-jurisdiction',
        },
        {
          name: 'Isle of Man as a Jurisdiction',
          link: '/isle-man-jurisdiction',
        },
        {
          name: 'Malta Jurisdiction',
          link: '/malta-jurisdiction',
        },
        {
          name: 'Cyprus Jurisdiction',
          link: '/cyprus-jurisdiction',
        },
        {
          name: 'Panama Jurisdiction',
          link: '/panama-jurisdiction',
        },
        {
          name: 'Seychelles Jurisdiction',
          link: '/seychelles-jurisdiction',
        },
        {
          name: 'Curaçao Jurisdiction',
          link: '/mauritius-jurisdiction',
        },
        {
          name: 'St. Vincent & the Grenadines (SVG) as a Jurisdiction',
          link: '/st-vincent-jurisdiction',
        },
        {
          name: 'United Arab Emirates (UAE) Jurisdiction',
          link: '/united-arab-emirates-jurisdiction',
        },
        {
          name: 'United Kingdom Jurisdiction',
          link: '/united-kingdom-jurisdiction',
        },
        {
          name: 'Singapore Jurisdiction',
          link: '/singapore-jurisdiction',
        },
        {
          name: 'Indonesia Jurisdiction',
          link: '/indonesia-jurisdiction',
        },
        {
          name: 'Greece Jurisdiction',
          link: '/greece-jurisdiction',
        },
        {
          name: 'Spain Jurisdiction',
          link: '/spain-jurisdiction',
        },
        {
          name: 'Italy Jurisdiction',
          link: '/italy-jurisdiction',
        },
        {
          name: 'Dominica Jurisdiction',
          link: '/dominica-jurisdiction',
        },
        {
          name: 'Maritime & Shipping Licenses – Panama',
          link: '/maritime-shipping-license-panama',
        },
      ],
    },
    {
      id: 'company-formation',
      name: 'Company Formation',
      links: [
        {
          name: 'Offshore company-formation',
          link: '/offshore-company-formation',
        },
        {
          name: 'Western Sahara IBC (International Business Company)',
          link: '/western-sahara-ibc',
        },
        {
          name: 'Mwali IBC (International Business Company)',
          link: '/mwali-ibc',
        },
        {
          name: 'Anjouan IBC (International Business Company)',
          link: '/anjouan-ibc',
        },
        {
          name: 'Cyprus company-formation',
          link: '/cyprus-company-formation',
        },
        {
          name: 'St. Lucia company-formation',
          link: '/st-lucia-company-formation',
        },
        {
          name: 'UK company-formation',
          link: '/uk-company-formation',
        },
        {
          name: 'Indonesia company-formation (PT PMA)',
          link: '/indonesia-company-formation',
        },
        {
          name: 'Panama company-formation',
          link: '/panama-company-formation',
        },
        {
          name: 'Malta company-formation',
          link: '/malta-company-formation',
        },
        {
          name: 'Mauritius company-formation',
          link: '/mauritius-company-formation',
        },
        {
          name: 'Isle of Man company-formation',
          link: '/isle-man-company-formation',
        },
        {
          name: 'St. Vincent company-formation',
          link: '/st-vincent-company-formation',
        },
        {
          name: 'UAE company-formation',
          link: '/uae--company-formation',
        },
        {
          name: 'Singapore company-formation',
          link: '/singapore-company-formation',
        },
        {
          name: 'company-formation in Seychelles',
          link: '/seychelles-company-formation',
        },
        {
          name: 'company-formation in Dominica',
          link: '/dominica-company-formation',
        },
        {
          name: 'Residency & Investment – Gibraltar',
          link: '/company-formation-gibraltar',
        },
        {
          name: 'Anjouan Offshore company-formation',
          link: '/anjouan-jurisdiction',
        },
        {
          name: 'Western Sahara Offshore company-formation',
          link: '/western-sahara-jurisdiction',
        },
        {
          name: 'Cyprus Offshore company-formation',
          link: '/cyprus-jurisdiction',
        },
      ],
    },
    {
      id: 'residency',
      name: 'Residency & Passport',
      links: [
        {
          name: 'Residency and Passport',
          link: '/residency-passport',
        },
        {
          name: 'Residency & Investment UAE',
          link: '/residency-passport',
        },
        { name: 'Golden visa Spain', link: '/golden-visa-spain' },
        { name: 'Golden visa Italy', link: '/golden-visa-italy' },
        { name: 'Residency Indonesia', link: '/residency-indonesia' },
        {
          name: 'Residency & Investment Cyprus',
          link: '/residency-investment-cyprus',
        },
        {
          name: 'Residency Citizenship Dominica',
          link: '/residency-citizenship-dominica',
        },
        {
          name: 'Residency & Investment Gibraltar',
          link: '/residency-investment-gibraltar',
        },
        {
          name: 'Residency & Investment – Isle of Man',
          link: '/residency-investment-isle-man',
        },
      ],
    },
    {
      id: 'investment',
      name: 'Real Estate Investment',
      links: [
        {
          name: 'Real Estate Investment',
          link: '/real-estate-investment',
        },
        {
          name: 'Real Estate Investment In UAE',
          link: '/real-estate-investment-uae',
        },
        {
          name: 'Real Estate Investment in Bali, Indonesia',
          link: '/real-estate-investment-bali-indonesia',
        },
        {
          name: 'Real Estate Investment in Cyprus',
          link: '/real-estate-investment-cyprus',
        },
        {
          name: 'Real Estate Investment in Italy',
          link: '/real-estate-investment-italy',
        },
        {
          name: 'Real Estate Investment in Greece',
          link: '/real-estate-investment-greece',
        },
      ],
    },
    {
      id: 'tax',
      name: 'Non-Dom Tax Regime',
      links: [
        {
          name: 'UK Non-Domiciled (Non-Dom) Tax Regime',
          link: '/uk-non-domiciled-tax-regime',
        },
        {
          name: 'Non Dom Tax Regime',
          link: '/non-dom-tax-regime',
        },
        {
          name: 'Italy Non Dom Tax Regime',
          link: '/ital-non-dom-tax-regime',
        },
      ],
    },
    {
      id: 'advisory',
      name: 'Financial & Advisory',
      links: [
        {
          name: 'Offshore Bank Opening Account',
          link: '/offshore-bank-account-opening',
        },
        {
          name: 'FinTech Services',
          link: '/fintech-services',
        },
        { name: 'Financial License', link: '/financial-license' },
        { name: 'Ready Made Companies', link: '/ready-made' },
        {
          name: 'Ready-Made Companies with Corporate Bank Accounts',
          link: '/ready-made-companies-corporate-bank-accounts',
        },
        { name: 'Assets Protection', link: '/assets-protection' },
      ],
    },
  ];

  // About + Areas из хедера
  const aboutLinks = [
    { name: 'About the Company', link: '/about' },
    { name: 'FAQ', link: '/faq' },
    { name: 'Why Offshore Advisory', link: '/why-offshore-advisory' },
    { name: 'Client Testimonials', link: '/client-testimonials' },
  ];

  const areasLinks = [
    {
      name: 'Offshore Company Registration',
      link: '/assets-protection',
    },
    { name: 'Licensing', link: '/financial-license' },
    {
      name: 'Opening bank accounts',
      link: '/offshore-bank-account-opening',
    },
    {
      name: 'Residency and Passport',
      link: '/residency-passport',
    },
    {
      name: 'Asset Management and Due Diligence',
      link: '/assets-protection',
    },
    { name: 'Ready-Made Companies', link: '/ready-made' },
    { name: 'Fintech Services', link: '/fintech-services' },
    {
      name: 'Meta Financial License',
      link: '/financial-license',
    },
  ];

  // ---------- STATE  ----------
  const [isMobile, setIsMobile] = useState(false);
  const [openSection, setOpenSection] = useState(null); // 'about' | 'services' | 'jurisdictions' | 'areas'
  const [openServiceItem, setOpenServiceItem] = useState(null);
  const [openJurItem, setOpenJurItem] = useState(null);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 1118;
      setIsMobile(mobile);

      if (!mobile) {
        setOpenSection(null); // dekstop all sections open
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleSection = (key) => {
    if (!isMobile) return;
    setOpenSection((prev) => (prev === key ? null : key));
  };

  const toggleServiceItem = (id) => {
    setOpenServiceItem((prev) => (prev === id ? null : id));
  };

  const toggleJurItem = (id) => {
    setOpenJurItem((prev) => (prev === id ? null : id));
  };

  const renderArrow = (isOpen) =>
    isOpen ? (
      <RiArrowUpSLine className="footer-toggle-arrow" />
    ) : (
      <RiArrowDownSLine className="footer-toggle-arrow" />
    );

  return (
    <main className="footer-background">
      <div className="footer-container">
        
        <div className="footer-navigate-content">
         
          <div className="footer-item-row-group">
            <button
              type="button"
              className="footer-section-button"
              onClick={() => toggleSection('about')}
            >
              <span className="footer-item-title">About Company</span>
              {isMobile && renderArrow(openSection === 'about')}
            </button>

            {(!isMobile || openSection === 'about') && (
              <div className="footer-item-group-1">
                {aboutLinks.map((item) => (
                  <NavLink key={item.link} to={item.link}>
                    {item.name}
                  </NavLink>
                ))}
              </div>
            )}
          </div>

          {/* OUR SERVICES */}
          <div className="footer-item-row-group">
            <button
              type="button"
              className="footer-section-button"
              onClick={() => toggleSection('services')}
            >
              <span className="footer-item-title">Our Services</span>
              {isMobile && renderArrow(openSection === 'services')}
            </button>

            {(!isMobile || openSection === 'services') && (
              <div className="footer-services-list">
                {servicesCategories.map((item) => {
                  const isOpen = openServiceItem === item.id;
                  return (
                    <div
                      className={`footer-services-item ${
                        isOpen ? 'open' : ''
                      }`}
                      key={item.id}
                    >
                      <button
                        type="button"
                        className="footer-services-item-button"
                        onClick={() => toggleServiceItem(item.id)}
                      >
                        <span className="footer-services-item-title">
                          {item.name}
                        </span>
                        {renderArrow(isOpen)}
                      </button>

                      {isOpen && (
                        <div className="footer-services-item-panel">
                          {item.links.map((link, index) => (
                            <NavLink
                              key={`${item.id}-${index}`}
                              to={link.link}
                            >
                              {link.name}
                            </NavLink>
                          ))}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            )}
          </div>

          {/* JURISDICTIONS & STRUCTURING */}
          <div className="footer-item-row-group">
            <button
              type="button"
              className="footer-section-button"
              onClick={() => toggleSection('jurisdictions')}
            >
              <span className="footer-item-title">Jurisdictions & Structuring</span>
              {isMobile && renderArrow(openSection === 'jurisdictions')}
            </button>

            {(!isMobile || openSection === 'jurisdictions') && (
              <div className="footer-services-list">
                {jurisdictionsCategories.map((item) => {
                  const isOpen = openJurItem === item.id;
                  return (
                    <div
                      className={`footer-services-item ${
                        isOpen ? 'open' : ''
                      }`}
                      key={item.id}
                    >
                      <button
                        type="button"
                        className="footer-services-item-button"
                        onClick={() => toggleJurItem(item.id)}
                      >
                        <span className="footer-services-item-title">
                          {item.name}
                        </span>
                        {renderArrow(isOpen)}
                      </button>

                      {isOpen && (
                        <div className="footer-services-item-panel">
                          {item.links.map((link, index) => (
                            <NavLink
                              key={`${item.id}-${index}`}
                              to={link.link}
                            >
                              {link.name}
                            </NavLink>
                          ))}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            )}
          </div>

          {/* AREAS */}
          <div className="footer-item-row-group">
            <button
              type="button"
              className="footer-section-button"
              onClick={() => toggleSection('areas')}
            >
              <span className="footer-item-title">Areas</span>
              {isMobile && renderArrow(openSection === 'areas')}
            </button>

            {(!isMobile || openSection === 'areas') && (
              <div className="footer-item-group-1">
                {areasLinks.map((item) => (
                  <NavLink key={item.link} to={item.link}>
                    {item.name}
                  </NavLink>
                ))}
              </div>
            )}
          </div>
        </div>

        
        <div className="footer-middle-content">
          <div className="footer-img-wrapper">
            <img src={HeaderLogo} alt="Offshore Advisory" />
            <span>Offshore Advisory</span>
          </div>
          <div className="footer-links-wrapper">
            <a href='https://www.linkedin.com/company/offshore-advisory-ltd/'>
              <img src={linkedInIcon} alt="Facebook" />
            </a>
            <a href='https://www.facebook.com/share/1BzUY37Eas/?mibextid=wwXIfr'>
              <img src={facebookIcon} alt="Facebook" />
            </a>
            <a href='https://calendly.com/offshoreadvisory-info/30min'>
              <img src={meeticon} alt="Facebook" />
            </a>
            {/* <a href=''>
              <img src={skypeIcon} alt="Skype" />
            </a> */}
            <a href='https://t.me/+447385054407'>
              <img src={telegramIcon} alt="Telegram" />
            </a>
            <a href='https://wa.me/44738505440'>
              <img src={whatsapIcon} alt="WhatsApp" />
            </a>
            <a href='https://www.instagram.com/globaladvisorycorp?igsh=MXQwbmloNzJmdTdweQ=='>
              <img src={instIcon} alt="Instagram" />
            </a>
          </div>
        </div>

        <div className="footer-bottom-content">
          <div className="footer-bottom-left">
            <NavLink to="/about">
              Privacy Policy
            </NavLink>
            <NavLink to="">
              Terms
            </NavLink>
            <NavLink to="">
              Copyright
            </NavLink>
            <span>
              ©
              {' '}
              {year}
              , Offshore Advisory
            </span>
          </div>

          <div className="footer-bottom-right">
            <a href="tel:+4407385054407">
              <div className="contact-item">
                <div className="contact-img-wrapper">
                  <img src={phoneIcon} alt="Phone" />
                </div>
                <span>+4407385054407</span>
              </div>
            </a>

            <a href="mailto:info@offshoreadvisory.pro">
              <div className="contact-item">
                <div className="contact-img-wrapper">
                  <img src={emailIcon} alt="Email" />
                </div>
                <div className="email-link">
                  <span>info@offshoreadvisory.pro</span>
                  <span>compliance@offshoreadvisory.pro</span>
                </div>
              </div>
            </a>

            <div className="contact-item">
              <div className="contact-img-wrapper">
                <img src={locationIcon} alt="Address" />
              </div>
              <span>25B RICHMOND TERRACE, LIVERPOOL, UNITED KINGDOM, L6 5HU</span>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}

export default Footer;
